export const RATE_TYPES = [
  { label: 'adjustable', value: 'adjustable' },
  { label: 'variable', value: 'variable' },
  { label: 'fixed', value: 'fixed' },
  { label: 'balloon', value: 'balloon' },
];
